import Backbone from 'backbone'
import _ from 'lodash'
import Tooltip from './tooltip'

var TruncatedTooltip = Backbone.View.extend({

	events: {
		'mouseenter': 'addTooltip',
		'mouseleave': 'removeToolip'
	},

	/**
	 * Tooltip displaying full name when text is truncated.
	 *
	 * @param {Object} options
	 *
	 * @param {JQuery|HTMLElement[]} [options.multipleTextEls] If more than one text element should be checked for truncation
	 *
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	// If text is overflowing and getting an ellipsis, add a tooltip on hover that displays
	// the full item name. Issue #25529
	addTooltip: function() {
		let isOverflowing = false
		if (this.options.multipleTextEls) {
			_.forEach(this.options.multipleTextEls, el => {
				if (el.scrollWidth > _.round(this.$(el).innerWidth())) {
					isOverflowing = true
				}
			})
		} else {
			isOverflowing = this.$el[0].scrollWidth > _.round(this.$el.innerWidth()) ? true : false
		}
		if (isOverflowing) {
			this.tooltip = new Tooltip({
				attachTo: this.$el,
				content: _.escape(this.$el.text()),
				placement: 'below',
				arrow: 'center',
				extraClass: 'no-max-width'
			}).render()
		}
	},

	removeToolip: function() {
		this.tooltip && this.tooltip.remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tooltip], 'remove')
	}
})

export default TruncatedTooltip


TruncatedTooltip.__filename__ = 'components/truncated-tooltip.js'
